import Customer from "../models/Customer";
import Duration from "../core/Duration";
import DateTime from "../core/DateTime";
import Order from "../models/Order";

export default class CustomerUtils {
  public constructor() {}
  public static getCustomersWithCompletedOrders(
    orders: Array<Order>
  ): Array<Customer> {
    let customers: Array<Customer> = [];

    let sixMonthsAgo: DateTime = DateTime.now().subtract(
      new Duration({ days: 180 })
    );

    for (let order of orders) {
      if (order.createdDate.isAfter(sixMonthsAgo)) {
        if (!customers.contains(order.customer)) {
          customers.add(order.customer);
        }
      }
    }

    return customers;
  }
}
